import * as React from 'react'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as hooks from '@owl-nest/hooks'
import * as models from '@owl-nest/models'

import { getCurrentLocale } from '../router'

import { AppBackbone } from '../components/AppBackbone'
import { CompactHeader } from '../components/CompactHeader'
import { NewsList } from './NewsList'

export type MembershipNewsListProps = {
  newsList: api.NewsListPage
  project: models.project.Project
}

export function MembershipNewsList({ newsList, project }: MembershipNewsListProps): React.ReactElement {
  const router = hooks.useNextRouter()
  const currentLocale = getCurrentLocale(router)

  const avatar = models.project.avatarImage(project, currentLocale, '290x290')
  const backgroundImage = models.project.mainImage(project, '2x', currentLocale)
  const name = models.project.name(project, currentLocale) ?? t('My page')

  return (
    <AppBackbone project={project}>
      <CompactHeader avatar={avatar} backgroundImage={backgroundImage} name={name} />
      <NewsList project={project} newsList={newsList} />
    </AppBackbone>
  )
}
